import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { FormattedMessage } from "react-intl";
import "./style.css";

const MainSpinner = () => {
    return (
        <div className="bis-mainSpinner">
            <FontAwesomeIcon icon={["fal", "spinner-third"]} spin />{" "}
            <span>
                <FormattedMessage id="general.loading" /> ...
            </span>
        </div>
    );
};

export default MainSpinner;
